import { API_BASE_URL } from "src/config/apiBase";
import React, { useEffect, useState } from "react";
import axios from "axios";
import FaqForm from "./FaqForm";
import { decryptToken } from "../utils/getToken";
import QuestionForm from "./QuestionForm";
import QuestionRow from "./QuestionRow";
import { Pen, Plus, Trash } from "lucide-react";
const FaqAdmin = () => {
  const [faqs, setFaqs] = useState([]);
  const [activeFaq, setActiveFaq] = useState(null);
  const [editFaqId, setEditFaqId] = useState(null);
  const [editHeading, setEditHeading] = useState("");

  const API = API_BASE_URL
  const token = decryptToken("accessToken") || "";

  const fetchFaqs = async () => {
    const res = await axios.get(`${API}/faq`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    setFaqs(res.data);
  };

  const updateFaq = async (id) => {
    await axios.put(
      `${API}/faq/${id}`,
      { heading: editHeading },
      { headers: { Authorization: `Bearer ${token}` } }
    );
    setEditFaqId(null);
    fetchFaqs();
  };

  const deleteFaq = async (id) => {
    if (!window.confirm("Delete FAQ?")) return;
    await axios.delete(`${API}/faq/${id}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    fetchFaqs();
  };

  useEffect(() => {
    fetchFaqs();
  }, []);

  return (
    <div className="hbtecom-faq-admin">
      <h1>FAQ Management</h1>

      <FaqForm refresh={fetchFaqs} />

      {faqs.map((faq) => (
        <div key={faq.id} className="faq-admin-card">
          <div className="faq-card-header">
            {editFaqId === faq.id ? (
              <>
                <input
                className="inputfaq-adminmainfaq"
                  value={editHeading}
                  onChange={(e) => setEditHeading(e.target.value)}
                />
                <div className="flexnewfaq-ques">
                <button className="savenow-faqnew" onClick={() => updateFaq(faq.id)}>Save</button>
                <button className="delete-quesfaq danger" onClick={() => setEditFaqId(null)}>
                  Cancel
                </button>
                </div>
              </>
            ) : (
              <>
                <h3 className="faq-title">{faq.heading}</h3>
                <div className="faq-actions">
                  <button
                    className="icon-btn"
                    onClick={() => {
                      setEditFaqId(faq.id);
                      setEditHeading(faq.heading);
                    }}
                  >
                    <Pen size={18}/>
                  </button>
                  <button
                    className="icon-btn"
                    onClick={() => setActiveFaq(faq.id)}
                  >
                    <Plus size={18}/>
                  </button>
                  <button
                    className="icon-btn danger"
                    onClick={() => deleteFaq(faq.id)}
                  >
                    <Trash size={18}/>
                  </button>
                </div>
              </>
            )}
          </div>

          {activeFaq === faq.id && (
            <QuestionForm faqId={faq.id} refresh={fetchFaqs} />
          )}

          {faq.questions.map((q) => (
            <QuestionRow key={q.id} q={q} refresh={fetchFaqs} />
          ))}
        </div>
      ))}
    </div>
  );
};

export default FaqAdmin;
